// @flow

/**
 * Get most recent open enrollment period:
 * If the date is before the end of this year's oep date, 11/1 ~ 12/15, the "previous oep" should still be last year
 * We set the ope cutoffDate on next day, 12/16.
 *
 * [note]:
 * OEP sometimes extends a few hours, e.g. if extended to 12/16 3am, the cutoff time will postpone.
 * Add the 'extendedDateTime' to accomadate the possibility to pass in a changable dtaeTime.
 * However, this is a special case, and we don't have a way to config every years OEP time for this changes at the moment.
 */
export function getRecentOepYear(extendedDateTime?: string) {
  const now = new Date();
  const oepEndDate = '12/16/';
  const year = now.getFullYear();
  const cutoffDate = extendedDateTime
    ? new Date(extendedDateTime)
    : new Date(`${oepEndDate}${year}`);
  return now < cutoffDate ? year - 1 : year;
}

export function getNextOepYear() {
  const now = new Date();
  return now.getMonth() >= 10 ? now.getFullYear() + 1 : now.getFullYear();
}
